export const SET_FREE_SHIPPING_AVAILABLE = 'SET_FREE_SHIPPING_AVAILABLE';

/** @namespace Pwa/Store/Shipping/Action/setFreeShippingAvailable */
export const setFreeShippingAvailable = (isAvailable) => ({
    type: SET_FREE_SHIPPING_AVAILABLE,
    payload: isAvailable
});
